import { PaginatedResponse, Sector } from "@cabukaka/types";
import { dataService } from "./core/dataService"
import { getConfig } from "@cabukaka/config";
import axios from "axios";

export const sectorService = {
    get baseService() {
        return dataService<Sector>("sectors");
    },
    getSectors: async (): Promise<PaginatedResponse<Sector>> => {
        return await dataService<Sector>("sectors").getAll()
    },

    updateOrder: async (orderData: { id: string; order: number }[], token?: string): Promise<Sector | null> => {
        const { apiUrl } = getConfig();
        try {
            const res = await axios.put(`${apiUrl}/sectors/re-order`, 
                { sectors: orderData }, // 👈 Envoyer les données dans un objet "sectors"
                {
                    headers: token ? { Authorization: `Bearer ${token}` } : {}
                }
            );
            return res.data;
        } catch (error) {
            console.error(error);
            return null;
        }
    }
}